module.exports = __webpack_public_path__ + "img/av011.ae52dba4.png";